module.exports = __webpack_public_path__ + "e9d82641444c7c54aa27d7eb51dd8af5.png";